import { BUSINESS_BOOKER_USER_ROLES, Channel } from '@whitbread-eos/api';
import { nanoid } from 'nanoid';
import decodeIdToken from '../utils/decodeIdToken';
export var TOKEN_COMPANY_FIELD = 'https://premierinn.com/companyAccountId';
export var TOKEN_EMPLOYEE_FIELD = 'https://premierinn.com/employeeAccountId';
export var TOKEN_EMAIL_FIELD = 'https://premierinn.com/email';
export var TOKEN_CUSTOMER_FIELD = 'https://premierinn.com/customerAccountId';
export function getChannelByToken(token) {
  if (!token) {
    return null;
  }
  var _getDetailsFromToken = getDetailsFromToken(token),
    accessLevel = _getDetailsFromToken.accessLevel,
    companyId = _getDetailsFromToken.companyId,
    employeeId = _getDetailsFromToken.employeeId,
    profile = _getDetailsFromToken.profile,
    customerId = _getDetailsFromToken.customerId;
  if (accessLevel && companyId && employeeId && profile !== null && profile !== void 0 && profile.isBusiness) {
    return Channel.Bb;
  }
  if (customerId && !(profile !== null && profile !== void 0 && profile.isBusiness) && !accessLevel) {
    return Channel.Pi;
  }
  return null;
}
export var getDetailsFromToken = token => {
  var _profile;
  var decodedToken = decodeIdToken(token);
  var companyId = decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken[TOKEN_COMPANY_FIELD];
  var employeeId = decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken[TOKEN_EMPLOYEE_FIELD];
  var customerId = decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken[TOKEN_CUSTOMER_FIELD];
  var email = decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken[TOKEN_EMAIL_FIELD];
  var accessLevel = decodedToken === null || decodedToken === void 0 || (_profile = decodedToken.profile) === null || _profile === void 0 ? void 0 : _profile.accessLevel;
  var profile = (decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.profile) || {};
  return {
    companyId,
    employeeId,
    customerId,
    email,
    accessLevel,
    profile,
    isTravelManager: accessLevel === BUSINESS_BOOKER_USER_ROLES.SUPER,
    isBooker: accessLevel === BUSINESS_BOOKER_USER_ROLES.BOOKER,
    isSelfBooker: accessLevel === BUSINESS_BOOKER_USER_ROLES.SELF,
    isGuest: accessLevel === BUSINESS_BOOKER_USER_ROLES.STAYER,
    isBusinessPayManager: accessLevel === BUSINESS_BOOKER_USER_ROLES.BUSINESS_PAY_MANAGER,
    isBusinessPayUser: accessLevel === BUSINESS_BOOKER_USER_ROLES.BUSINESS_PAY_USER
  };
};
export var getRandomTracingId = () => {
  return nanoid();
};
export { DEFAULT_TRACING_COOKIE_NAME, ID_TOKEN_COOKIE } from '../global-constants';